import { useState } from "react";
import { useTranslation } from "next-i18next";
import { SlideToggle, SubStepButtons } from "@talladega/components";
import {
  TUserType,
  CombinedFormInformation,
  UserType,
} from "../hooks/useBillOfSaleFormStepsReducer";
import { BuyerSellerFieldsInput } from "../types/BillOfSaleFormFields";
import SellerStep from "./SellerStep";
import BuyerStep from "./BuyerStep";

type Props = {
  onNext: (formData: BuyerSellerFieldsInput) => void;
  onUserTypeChange: (userType: TUserType) => void;
  formInformation: CombinedFormInformation;
  userType: TUserType | null;
};

const UserInformationStep = ({
  onNext,
  onUserTypeChange,
  formInformation,
  userType,
}: Props) => {
  const { t } = useTranslation(["billOfSalePage"]);
  // default the button to seller if userType is null
  const [isSeller, setIsSeller] = useState<boolean>(
    userType === null || userType === UserType.Seller
  );
  const [showForm, setShowForm] = useState<boolean>(userType !== null);

  return (
    <>
      <div className="mt-6 p-8 w-full border rounded-xl border-gray-200">
        <h5 className="mb-4">
          {t("billOfSalePage:are_you_selling_or_buying")}
        </h5>
        <SlideToggle
          leftLabel={t("billOfSalePage:selling")}
          leftValue={UserType.Seller}
          rightLabel={t("billOfSalePage:buying")}
          rightValue={UserType.Buyer}
          value={isSeller ? UserType.Seller : UserType.Buyer}
          onChange={(option) => {
            setIsSeller(UserType.Seller === option);
            onUserTypeChange(option as TUserType);
          }}
        />
        {!showForm && (
          <div className="mt-6">
            <SubStepButtons
              hideBackButton
              nextButton={{
                onClick: () => {
                  setShowForm(true);
                  onUserTypeChange(isSeller ? UserType.Seller : UserType.Buyer);
                },
              }}
            />
          </div>
        )}
      </div>
      {showForm &&
        (isSeller ? (
          <SellerStep
            hideBackButton
            onNext={onNext}
            formInformation={formInformation}
            required
          />
        ) : (
          <BuyerStep
            hideBackButton
            onNext={onNext}
            formInformation={formInformation}
            required
          />
        ))}
    </>
  );
};

export default UserInformationStep;
